module.exports = __webpack_public_path__ + "img/skor-sertifikat-resize.5145cd6b.jpg";